<template>
    <div class="l-row">
        <button
            class="a-button a-button--menu"
            :class="{ 'a-button--menuActive': menu }"
            @click="menu = !menu"
        ></button>
        <div
            class="l-row__column a-tabs a-tabs--dashboardTabs a-tabs--mobileMenu"
            :class="{ 'a-tabs--mobileMenuVisible': menu }"
        >
            <div class="a-tabs__container">
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.name === 'dashboard-summary'
                    }"
                    @click="menuClick('dashboard-summary')"
                >
                    <p class="a-text">Dashboard</p>
                </div>
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.path.includes('order')
                    }"
                    @click="menuClick('delivery-address')"
                >
                    <p class="a-text">Nowe zamówienie</p>
                </div>
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.name === 'dashboard-delivery'
                    }"
                    @click="menuClick('dashboard-delivery')"
                >
                    <p class="a-text">Dostawy</p>
                </div>
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.name === 'dashboard-offers'
                    }"
                    @click="menuClick('dashboard-offers')"
                >
                    <p class="a-text">Oferty</p>
                </div>
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.name === 'dashboard-invoices'
                    }"
                    @click="menuClick('dashboard-invoices')"
                >
                    <p class="a-text">Faktury</p>
                </div>
                <div
                    class="a-tabs__tab"
                    :class="{
                        'a-tabs__tab--active':
                            $route.name === 'dashboard-company'
                    }"
                    @click="menuClick('dashboard-company')"
                >
                    <p class="a-text">Moja Firma</p>
                </div>
                <div
                    class="a-tabs__tab a-tabs__tab--mobileOnly"
                    @click="menuClick('dashboard-logout')"
                >
                    <p class="a-text">Wyloguj</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            menu: false,
            isMobile: false
        }
    },
    mounted() {
        this.checkIfMobile()
    },
    methods: {
        checkIfMobile() {
            if (window.innerWidth < 1024) {
                this.isMobile = true
            } else {
                this.isMobile = false
            }
        },
        menuClick(name) {
            this.menu = false
            this.$router.push({ name }).catch(() => {})
        }
    }
}
</script>
